<template>
    <div class="select_product" @click="closePanel">
        <div class="product_panel" @click.stop="openPanel(0, $event)">
            <img src="../../assets/img/select/select_products1.svg" alt="ヨコ型ブラインド">
            <p>ヨコ型ブラインド</p>
        </div>
        <div class="product_panel" @click.stop="openPanel(1, $event)">
            <img src="../../assets/img/select/select_products2.svg" alt="木製ブラインド">
            <p>木製ブラインド</p>
        </div>
        <div class="product_panel" @click.stop="openPanel(2, $event)">
            <img src="../../assets/img/select/select_products3.svg" alt="タテ型ブラインド">
            <p>タテ型ブラインド</p>
        </div>
        <div class="product_panel" @click.stop="openPanel(7, $event)">
            <img src="../../assets/img/select/select_products8.svg" alt="調光タテ型ブラインド">
            <p>調光タテ型<span style="display: inline-block">ブラインド</span></p>
        </div>
        <div class="product_panel" @click.stop="openPanel(3, $event)">
            <img src="../../assets/img/select/select_products4.svg" alt="ロールスクリーン ">
            <p>ロールスクリーン </p>
        </div>
        <div class="product_panel" @click.stop="openPanel(4, $event)">
            <img src="../../assets/img/select/select_products5.svg" alt="調光ロールスクリーン ">
            <p>調光<br>ロールスクリーン </p>
        </div>
        <div class="product_panel" @click.stop="openPanel(5, $event)">
            <img src="../../assets/img/select/select_products6.svg" alt="プリーツスクリーン ">
            <p>プリーツ<br>スクリーン </p>
        </div>
        <div class="product_panel" @click.stop="openPanel(6, $event)">
            <img src="../../assets/img/select/select_products7.svg" alt="ハニカムスクリーン">
            <p>ハニカム<br>スクリーン </p>
        </div>
        <div class="product_selector_parent" :style="panelPos">
            <div class="product_selector_container"
                :class="{opened: open, ...selectedId}"
            >
                <SetProductType
                    ref="subModal"
                    @closeModal="closeModal"
                    :typeList="typeList"
                    @clearSettle="clearSettle"
                    :settle.sync="promiseToSettle"
                 />
            </div>
            <div class="product_selector_sub" :class="{ active: promiseToSettle !== null }">
                <SetPairCombi :to-settle="promiseToSettle" />
            </div>
        </div>
    </div>
</template>

<script>
    import { mapMutations , mapActions} from 'vuex'
    // import SelectPosition from "./AddItem/SelectPosition";
    import SetProductType from "./parts/SetProductType";
    import SetPairCombi from "./SetPairCombi.vue"
    import productType from '../../assets/json/productType.json'

    const productId = ['horA', 'horW', 'ver', 'roll', 'roll2', 'pleats', 'hanicam', 'laver']

    export default {
        name: "SelectProduct",
        components: {
            // SelectPosition,
            SetProductType,
            SetPairCombi
        },
        data: () => ({
            open: false,
            panelPos: {},
            selectedId: {},
            productIndex: -1,
            typeList: [],
            subModal: null,
            promiseToSettle: null, // { resolve(), reject() }
        }),
        destroyed() {
        },
        methods: {
            ...mapMutations(["setModal"]),
            ...mapMutations('simulator', ["deleteTempItem"]),
            ...mapActions(["resetTimer"]),
            ...mapActions('simulator', ["commitTempItem"]),
            hasDefaultType (types) {
                return types.length === 1 && types[0]?.defaultType
            },
            async openPanel (idx, ev) {
                const { currentTarget } = ev
                // reset to initial state
                this.clearSettle()
                this.$refs.subModal.resetActiveType()
                document.querySelectorAll('.product_panel.opened').forEach(el => el.classList.remove('opened'))
                // set selected product type
                const productMeta = productType.find(({id}) => id === idx + 1)
                const { prefix, feature } = productMeta
                this.typeList = productMeta.types.map(meta => ({prefix, feature, ...meta}))
                this.productIndex = idx
                this.selectedId = { [productId[idx]]: true }
                // close modal if only one type
                if (this.hasDefaultType(this.typeList)) {
                    const {
                        prefix,
                        type,
                        feature,
                        slatWidth,
                        shield,
                        weight_bar,
                        display,
                        default: itemList } = this.typeList[0]
                    await this.$refs.subModal.setProductType(
                        prefix, type, feature, slatWidth, shield, weight_bar, display, itemList,
                        false, // reverse
                        false // is_upper_lace
                    )
                    this.closeModal()
                    return
                }
                // open sub model to select type
                currentTarget.classList.toggle('opened')
                const modalRect = currentTarget.parentNode.getBoundingClientRect()
                const modalBoundary = modalRect.x + modalRect.width / 2;
                if (['roll', 'hanicam'].includes(productId[idx])) {
                    this.panelPos = { justifyContent: 'center' }
                }
                else if (modalBoundary > ev.clientX) {
                    // this.panelPos = { left: 'auto', right: 0 }
                    this.panelPos = { justifyContent: 'flex-end' }
                } else {
                    // this.panelPos = { left: 0, right: 'auto' }
                    this.panelPos = { justifyContent: 'flex-start' }
                }
                this.open = this.open || !this.open
            },
            clearSettle (){
                if (this.promiseToSettle !== null) {
                    this.promiseToSettle?.reject()
                    this.promiseToSettle = null
                }
            },
            closePanel () {
                document.querySelectorAll('.product_panel.opened').forEach(el => el.classList.remove('opened'))
                this.productIndex = -1
                this.selectedId = {}
                this.open = false
                this.clearSettle()
                this.$refs.subModal.resetActiveType()
            },
            closeModal () {
                this.setModal('')
                this.clearSettle()
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/define";

    .select_product {
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        justify-content: space-between;
        height: 100%;
        position: relative;
        > .product_panel {
            width: calc(25% - 7px);
            height: calc(50% - 22px);
            text-align: center;
            padding: 5px 0;
            border:1px solid transparent;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            justify-content: center;
            &.opened {
                border: 1px solid #000;
            }
            p{
                text-align: center;
                margin: 5px 0;
                line-height: 1.2;
                font-size: clamp(10px, 1.2vw, 18px);
            }
            @media (max-width: 739px) {
                p{
                    font-size: 10px;
                    margin: 0;
                }
            }
            img{
                max-height: 75%;
                height: 100%;
                max-width: 100%;
            }
            @media (max-width: 999px) {
                img{
                    max-height: 70%;
                }
            }
        }
        .product_panel:nth-child(5) {
            img{
                max-height: 80%;
            }
        }
        .product_selector_parent {
            position: absolute;
            display: flex;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            pointer-events: none;
            z-index: 1;
            .product_selector_container {
                display: none;
                pointer-events: auto;
                z-index: 3;
                &.opened {
                    // position: absolute;
                    display: block;
                    width: calc(174 / 349 * 100%);
                    &.horA{
                        width: calc(262 / 349 * 100%);
                    }
                    height: 100%;
                    background-color: rgba($color: #222, $alpha: 0.8);
                }
                // &.opened.roll,
                // &.opened.hanicam{
                //     left: 25% !important;
                //     right: auto !important;
                // }
            }
            .product_selector_sub {
                pointer-events: auto;
                display: flex;
                justify-content: flex-end;
                width: 0;
                height: 100%;
                overflow: hidden;
                background-color: rgba(0, 0, 0, 0.5);
                z-index: 2;
                transform: translateX(-100%);
                opacity: 0;
                &.active {
                    width: calc((349 - 174) / 349 * 50%);
                    transition: transform 0.3s, opacity 0.2s;
                    transform: translateX(0);
                    opacity: 1;
                }
            }
        }
    }
</style>
